<template>
  <with-actions>
    <div class="form-inline ml-auto" slot="context-actions" v-if="can('write_mail_templates')">
      <router-link class="btn btn-primary" :to="{ name: 'mail_template_create' }">{{
        'new_mail_template' | t
      }}</router-link>
    </div>
    <lazy-table v-model="mail_templates" model="mail_templates" :params="params">
      <table class="table table-hover">
        <thead>
          <tr>
            <th>{{ 'name' | t }}</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(template, idx) in mail_templates">
            <router-link
              :to="{ name: 'mail_template_edit', params: { mail_template_id: template.id } }"
              tag="td"
              :key="template.id"
              role="button"
              >{{ template.name }}</router-link
            >
            <td class="text-right">
              <a
                class="text-danger"
                @click="
                  confirmModal(
                    $event,
                    $i18n.t('are_you_sure'),
                    $i18n.t('delete_mail_template'),
                    delete_template,
                    template,
                    idx
                  )
                "
                >{{ 'delete' | t }}</a
              >
            </td>
          </tr>
        </tbody>
      </table>
    </lazy-table>
  </with-actions>
</template>
<script>
import Api from '@/store/jsonapi';
import Alerts, { handle } from '@/utils/alerts';

export default {
  data: function () {
    return {
      mail_templates: [],
      params: {}
    };
  },
  methods: {
    delete_template: handle(async function (template, idx) {
      await Api.destroy('mail_templates', template.id);
      this.mail_templates.splice(idx, 1);
      Alerts.success({ title: 'Template was destroyed' });
    }),
    load() {
      this.setBreadcrumbs([
        { to: { name: 'settings_index' }, text: this.$t('settings') },
        {
          to: { name: 'mail_templates' },
          text: this.$t('routes_mail_templates')
        }
      ]);
    }
  },
  mounted: function () {
    this.load();
  }
};
</script>

<style scoped></style>
